import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetDatasourceCertificationParams {
  id: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetDatasourceCertificationRequest extends Request<ISetDatasourceCertificationParams, IEmptyResult> {
  constructor(params: ISetDatasourceCertificationParams) {
    super('setDatasourceCertification', params);
  }
}
